module.exports = __webpack_public_path__ + "static/cars_night_mobile-ec9767d71750da1b5436b9f499ab272b.jpg";